import { LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

import primaryConradIcon from 'src/assets/logos/conrad-icon.png'
import whiteConradIcon from 'src/assets/logos/white-conrad-icon.png'

type ConradLogoProps = LucideProps & {
  color?: 'white' | 'primary'
}

export const ConradIcon = forwardRef<SVGSVGElement, ConradLogoProps>(
  ({ size = 24, color = 'primary', ...props }, ref) => {
    const logoSrc = color === 'white' ? whiteConradIcon : primaryConradIcon

    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <image href={logoSrc} width="24" height="24" preserveAspectRatio="xMidYMid meet" />
      </svg>
    )
  },
)

ConradIcon.displayName = 'ConradIcon'
